





















































import Vue from 'vue';
import {
  DocuSignTemplateAdditionalDocumentConfigurationModel,
  DocuSignTemplateAdditionalDocumentCreateUpdateModel,
  DocuSignTemplateAdditionalDocumentModel,
  DocuSignTemplateAdditionalDocumentSearchModel,
  Dictionary,
  Configuration
} from '@/types';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
// tslint:disable-next-line:max-line-length
import DocuSignUpdateTemplateAdditionalDocument from '@/components/configuration/docuSign/DocuSignUpdateTemplateAdditionalDocument.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
export default Vue.extend({
  name: 'DocusignEditTemplateAdditionalDocument',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  data() {
    return {
      isLoading: true,
      submitIsLoading: false,
      serverValidationMessage: '',
      templateAdditionalDocumentConfigurationModel: {} as DocuSignTemplateAdditionalDocumentConfigurationModel,
      templateAdditionalDocumentModel: {} as DocuSignTemplateAdditionalDocumentModel
    };
  },
  methods: {
    navigateToTemplateAdditionalDocumentManagement(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.DocuSign.TemplateAdditionalDocument.Management.name,
        params: param
      });
    },
    async getData(this: any, id: number) {
      this.isLoading = true;
      try {
        // tslint:disable-next-line:max-line-length
        this.templateAdditionalDocumentConfigurationModel = await DocuSignConfigurationService.getTemplateAdditionalDocumentConfiguration(
          {
            documentTypeId: this.documentTypeId,
            templateId: this.templateId,
            templateAdditionalDocumentId: this.templateAdditionalDocumentId
          } as DocuSignTemplateAdditionalDocumentSearchModel
        );
        // tslint:disable-next-line:max-line-length
        this.templateAdditionalDocumentModel = this.templateAdditionalDocumentConfigurationModel.templateAdditionalDocument;
      } catch (error) {
        this.$log('Error getting tenmplate additional document configuration', error);
      } finally {
        this.isLoading = false;
      }
    },
    async onSubmit(this: any, templateAdditionalDocument: DocuSignTemplateAdditionalDocumentCreateUpdateModel) {
      this.resetFormValidation();
      try {
        this.submitIsLoading = true;
        const result = await DocuSignConfigurationService.updateTemplateAdditionalDocumentAsync(
          this.templateAdditionalDocumentId,
          templateAdditionalDocument
        );
        if (result.hasNotification && !result.showToast) {
          this.serverValidationMessage = result.notification;
          this.submitIsLoading = false;
          return;
        }

        SnotifyConfiguration.showSuccess('Template Additional Document updated successfully.');
        this.setApplicationDirty(false);
        this.navigateToTemplateAdditionalDocumentManagement();
      } catch (error) {
        this.serverValidationMessage = 'Error updating Template Additional Document';
      } finally {
        this.submitIsLoading = false;
      }
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    },
    templateAdditionalDocumentId(): number {
      return Number(this.$route.params.id);
    }
  },
  mounted(this: any) {
    this.getData();
  },
  components: {
    LoadingSpinner,
    DocuSignUpdateTemplateAdditionalDocument
  }
});
